import React, { useRef, useState } from 'react'
import { checkValidateData } from '../utils/validate'; 
import { LOGIN_URL } from '../utils/constants';
import { useNavigate } from 'react-router-dom';
import { addUser } from '../utils/userSlice';
import { useDispatch } from 'react-redux';  
import useRedirectIfLoggedIn from '../utils/useRedirectIfLoggedIn';
 
import logo from "../assets/images/logo-dark.png";
 

const Login = () => {

 
  //  useRedirectIfLoggedIn();

  //console.log("afsd");
    const dispatch = useDispatch();  
    const Navigate = useNavigate();     
    const email = useRef(null);
    const password = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null); 

  const handleButtonClick = async () => {
    const message = checkValidateData(
      email.current.value,
      password.current.value
    );

    setErrorMessage(message);
    if (message) return;

    const formData = {
      email: email.current.value,
      password: password.current.value,
    };

    try {
      const response = await fetch(LOGIN_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (data.error) {
        let loginerr = document.getElementById("loginerror");
        loginerr.innerText = data.error;
        return;
      }

      if (data.sucess === true) {
        dispatch(addUser(data?.data));
        Navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  }; 


  return (
    <div className="bg-slate-100 min-h-screen grid md:grid-cols-2 grid-cols-1 justify-items-center items-center px-5">
      {/* Left Section (Hidden on small screens) */}
      <div className="flex justify-center hidden sm:flex">
        <div className="w-full px-5 text-center">
          <div className="text-sky-700 text-3xl font-bold">
            Admin Login
          </div>
          <div className="pb-3 w-11/12 mx-auto"></div>
          <div className="grid justify-center"></div>
        </div>
      </div>

      {/* Right Section (Login Form) */}
      <div className="w-full flex justify-center items-center">
        <div className="shadow-md 2xl:w-3/5 lg:w-4/5 ssm:w-full container py-5 px-5 rounded-md bg-white">
          {/* Logo */}
          <div className="flex justify-center py-5">
            <img className="h-20 w-20 object-contain" src={logo} alt="logo" />
          </div>

          {/* Sign-in Heading */}
          <div className="text-sky-700 text-3xl font-bold pb-5 text-center">
            Sign In
          </div>

          <div id="loginerror" className="text-center text-red-500"></div>

          {/* Form */}
          <div className="space-y-5 px-5">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex flex-col space-y-3"
              id="loginForm"
            >
              <label
                htmlFor="email"
                className="text-gray-700 text-base font-bold"
              >
                Email
              </label>
              <input
                ref={email}
                className="border-2 focus:outline-none focus:border-sky-700 w-full px-2 py-1 rounded-md"
                type="email"
                id="email"
                placeholder="Enter your email"
              />

              <label
                htmlFor="password"
                className="text-gray-700 text-base font-bold"
              >
                Password
              </label>
              <input
                ref={password}
                className="border-2 focus:outline-none focus:border-sky-700 w-full px-2 py-1 rounded-md"
                id="password"
                name="password"
                type="password"
                placeholder="Enter your password"
              />

              {errorMessage && <p className="text-red-700">{errorMessage}</p>}

              <button
                onClick={handleButtonClick}
                type="submit"
                className="bg-sky-700 w-full text-white font-bold py-2 rounded-md"
              >
                Sign In
              </button>
            </form>

            {/* Footer Links */}
            <div className="text-center text-sm text-gray-600">
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              <a className="text-sky-700 font-bold mx-1" href="#">
                Terms of Use
              </a>{" "}
              and
              <a className="text-sky-700 font-bold mx-1" href="#">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login